import { cn } from "kz-ui-sdk";
import { OnboardingDialogStep } from "../../constants";
import { OnboardingDialogProps } from "../../types";
import DialogLayoutRenderer from "../DialogLayoutRenderer";
import PostLoginInfoStep from "../DialogSharedSteps/components/PostLoginInfoStep";
import { ForgotSecretStep, LoginStep, OnboardStep, RegisterStep } from "./components";

const DialogPhonePin = ({
  isOpen,
  handleClose,
  stepNavigate,
  onboardingMode,
  step,
  callback,
  layout,
}: OnboardingDialogProps) => {
  return (
    <DialogLayoutRenderer
      layout={layout}
      isOpen={isOpen}
      onClose={handleClose}
      classes={{
        drawer: {
          "container&": cn("!px-4", {
            "!pb-4": step === OnboardingDialogStep.Onboarding && onboardingMode,
          }),
        },
      }}
    >
      {/*ONBOARDING STEP*/}
      {step === OnboardingDialogStep.Onboarding && onboardingMode && (
        <OnboardStep
          defaultMode={onboardingMode}
          navigate={stepNavigate}
          handleClose={handleClose}
          layout={layout}
        />
      )}

      {/*LOGIN STEP*/}
      {step === OnboardingDialogStep.Login && (
        <LoginStep
          navigate={stepNavigate}
          handleClose={handleClose}
          layout={layout}
        />
      )}

      {/*REGISTER STEP*/}
      {step === OnboardingDialogStep.Register && (
        <RegisterStep
          navigate={stepNavigate}
          handleClose={handleClose}
          layout={layout}
        />
      )}

      {/*FORGOT PIN STEP*/}
      {step === OnboardingDialogStep.ForgotSecret && (
        <ForgotSecretStep
          navigate={stepNavigate}
          handleClose={handleClose}
          layout={layout}
        />
      )}

      {/*POST LOGIN INFO STEP*/}
      <PostLoginInfoStep
        step={step}
        stepNavigate={stepNavigate}
        handleClose={handleClose}
        layout={layout}
        callback={callback}
      />
    </DialogLayoutRenderer>
  );
};

export default DialogPhonePin;
